import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../../../../services';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-heartlands-callback',
  templateUrl: './heartlands-callback.component.html',
  styleUrls: ['./heartlands-callback.component.scss']
})
export class HeartlandsCallbackComponent {
private code: string = '';
  constructor(
    private route: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    public helpersService: HelpersService,
    private router: Router
  ) {}

  ngOnInit() {
    var partnerData = this.helpersService.getPartnerData();
    console.log(this.route);
    this.code = this.route.snapshot.queryParams['code'];

    this.code = this.code == null ? '' : this.code;
    console.log(this.code);

    if (this.code != '') {
      if (partnerData != undefined) {
        this.posIntegrationService
          .ProcessHeartlandsCallback(partnerData.ID, this.code)
          .subscribe((res) => {
            console.log(res, 'result');
            this.router.navigate(['/bikeshop/pos-integrations']);
          });
      } else {
        alert('Partner details not available');
      }
    } else {
      alert('An error occurred');
    }
  }
}
